<template lang="pug">
	.audio-tracker-multiple-selection(v-if="isActive")
		.selector(:style="{ left: `${sizeData.start[0] || 0}px`, top: `${sizeData.start[1] || 0}px`, width: `${sizeData.width}px`, height: `${sizeData.height}px` }")
</template>
<script>
	import $ from 'jquery';
	import _ from 'lodash';

	const SHIFT_KEY = 16;

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-multiple-selection',
		props: ['tracker', 'value'],
		model: {
			prop: 'value',
			event: 'change'
		},
		data() {
			return {
				isShiftPressed: false,
				isMouseDown: false,
				start: [],
				end: [],
				selectedItems: [],
				selectedIds: []
			};
		},
		watch: {
			isShiftPressed(v) {
				if (__DEBUG__)
					console.debug('Shift key', v);
				this.$emit('shift', v);
			},
			sizeData(v) {
				this.$emit('sizeData', v);
			},
			selectedIds() {
				if (__DEBUG__)
					console.debug('Selection changed', this.selectedIds, this.selectedItems);
				this.$emit('change', this.selectedIds);
			},
			'value'(v) {
				if (`${this.selectedIds}` !== `${v}`) {
					this.selectedIds = v;
					this.selectedItems = Object.keys(this.tracker.$refs).map(f => {
						var id = `${f}`.replace('trackCanvas_', '');
						if (this.selectedIds.some(v => v === id)) {
							var item = this.getTrackCanvasInfo(f);
							if (item.track) {
								return item;
							}
						}
					}).filter(f => f);
				}
			}
		},
		computed: {
			sizeData() {
				var start = [
					Math.max(0, Math.min(this.start[0] || 0, this.end[0] || 0)),
					Math.max(0, Math.min(this.start[1] || 0, this.end[1] || 0))
				];
				var end = [
					Math.max(0, Math.max(this.start[0] || 0, this.end[0] || 0)),
					Math.max(0, Math.max(this.start[1] || 0, this.end[1] || 0))
				];
				var width = end[0] - start[0];
				var height = end[1] - start[1];
				return {
					start,
					end,
					width,
					height
				}
			},
			isActive() {
				return this.isShiftPressed && this.isMouseDown;
			}
		},		
		mounted() {
			if (__DEBUG__)
				window.multipleSelection = this;
			$('body').on('keydown', this.keyDown);
			$('body').on('keyup', this.keyUp);
			setImmediate(() => {
				if (this._isDestroyed) return;
				$(this.tracker.$refs.navigator).on('mousedown', this.mouseDown);
				$(this.tracker.$refs.navigator).on('mouseup', this.mouseUp);
				$(this.tracker.$refs.navigator).on('mousemove', this.mouseMove);
			});

			this.$calcSelectedItems = _.debounce(this.calcSelectedItems, 10, {
				'leading': false,
				'trailing': true
			});
		},
		destroyed() {
			$('body').off('keydown', this.keyDown);
			$('body').off('keyup', this.keyUp);
			$(this.tracker.$refs.navigator).off('mousedown', this.mouseDown);
			$(this.tracker.$refs.navigator).off('mouseup', this.mouseUp);
			$(this.tracker.$refs.navigator).off('mousemove', this.mouseMove);
			delete this.$calcSelectedItems;
		},
		methods: {
			clear() {
				this.start = [];
				this.end = [];
			},
			keyDown(e) {
				if (e.keyCode === SHIFT_KEY && !this.isShiftPressed) {
					this.isShiftPressed = true;
				}
			},
			keyUp(e) {
				if (e.keyCode === SHIFT_KEY && this.isShiftPressed) {
					this.isShiftPressed = false;
				}
			},
			mouseDown(e) {
				this.isMouseDown = true;
				if (this.isShiftPressed) {
					this.clear();
					var offset = $(this.tracker.$refs.navigator).offset();
					this.start = [e.clientX - offset.left, e.clientY - offset.top];
					this.end = [e.clientX - offset.left, e.clientY - offset.top];
					this.$calcSelectedItems();
					e.stopPropagation();
					e.preventDefault();
				}
			},
			mouseMove(e) {
				if (this.isActive) {
					var offset = $(this.tracker.$refs.navigator).offset();

					if (!this.start?.length) {
						this.start = [e.clientX - offset.left, e.clientY - offset.top];
					}
					this.end = [e.clientX - offset.left, e.clientY - offset.top];

					this.$calcSelectedItems();
					e.stopPropagation();
					e.preventDefault();
				}
			},
			mouseUp(e) {
				this.isMouseDown = false;
			},
			getTrackCanvasInfo(f) {
				var component = this.tracker.$refs[f][0];
				var el = component?.$el;
				if (!el) {
					return null;
				}
				var position = $(el).position();
				var trackPosition = $(el).parents('.track').position();

				return {
					trackId: component?.track?.id,
					track: component?.track,
					component,
					el,
					position,
					start: [position.left + trackPosition.left, position.top + trackPosition.top],
					end: [position.left + $(el).width() + trackPosition.left, position.top + $(el).height() + trackPosition.top]
				}
			},
			calcSelectedItems() {
				var canvases = Object.keys(this.tracker.$refs).filter(f => f.startsWith('trackCanvas_')).map(f => this.getTrackCanvasInfo(f));
				
				var canvasesItems = canvases.filter(f => f && this.isPointsIntersects(this.sizeData.start, this.sizeData.end, f.start, f.end));
				var selectedItems = canvasesItems.filter(f => !this.selectedItems.some(si => si.trackId === f.trackId));
				this.selectedItems.push(...selectedItems);

				if (selectedItems.length === 0 && canvasesItems.length === 1 && Math.max(this.sizeData.width, this.sizeData.height) < 10) {
					this.selectedItems.splice(_.findIndex(this.selectedItems, v => v.trackId === canvasesItems[0]?.trackId), 1);
				}

				var selectedTracks = this.selectedItems.map(f => f.track);
				if (`${this.selectedIds}` !== `${selectedTracks.map(f => f.id)}`) {
					this.selectedIds = selectedTracks.map(f => f.id);
				}

				return { selectedItems, canvases };
			},
			isPointsIntersects(start1, end1, start2, end2) {
				return start1[0] < end2[0] && end1[0] > start2[0] && start1[1] < end2[1] && end1[1] > start2[1];
			}
		}
	};
</script>

<style lang="scss">
	.audio-tracker-multiple-selection {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100%;
		pointer-events: none;
		user-select: none;
		z-index: 100;

		> .selector {
			position: absolute;
			border: 1px dashed #b2b2b2;
			border-radius: 3px;
		}
	}
</style>